import React from 'react'
import MaterialSymbol from '../material-symbol'

const FileCopy = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="file_copy" {...props} />
))

FileCopy.displayName = 'FileCopy'

export default FileCopy
